var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-header'),_vm._v(" "),_c('work-overlay',{staticClass:"header-breakpoint-hidden"}),_vm._v(" "),_c('div',{staticClass:"content-overlay",attrs:{"data-overlay":""}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('v-footer')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694af476","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Layout.vue
// module id = 606
// module chunks = 1